@if (_active) {
  <kendo-window
    [class.editFieldsModeClass]="_pageState == 4"
    title="{{ _pageState == 2 ? 'ADD NEW RECORD' : _pageState == 3 ? 'EDIT RECORD' : _pageState == 1 ? 'VIEW RECORD' : _pageState == 4 ? 'EDIT FIELDS MODE' : '' }}"
    (close)="_closeForm()"
    (stateChange)="_onStateChanges($event)"
    class="fullWidthFormForm"
    [class.disabledPopup]="_editFormActive || _orderingTabsForm || _deactivatedFieldsForm"
    (keydown.enter)="$event.preventDefault()">
    <form novalidate [formGroup]="_form" class="form_style">
      <div class="row special_row_margin">
        <div class="col-12 special_col_padding">
          <div class="border_sections margin-top-4">
            <div class="row">
              <div class="col-12">
                <h2 class="formsTitle">
                  Video
                  @if (canAccess(_permissionScope, 'update')) {
                    <span (click)="_edit()"
                      [class.ViewModeVisibleElement]="_pageState == 1"
                      class="action-button action-button-viewMode">
                      <div class="action-button-icon">
                        <img src="/assets/menu/enterprise/edit-action-icon-grid.svg" />
                      </div>
                      <div class="edit-icon-text">Edit</div>
                    </span>
                  }
                </h2>
                <div class="upsert-header-buttons">
                  <ul class="menuButtonsList">
                    @if (canAccess(_permissionScope, 'update')) {
                      <li (click)="_onEditForms()"
                        [class.ViewModelHiddenElement]="_pageState != 2">
                        Edit Forms
                      </li>
                    }
                    <!-- <li (click)="_onEditFields()" [class.ViewModeHiddenElement]="_pageState != 2">Edit
                  Fields</li>
                  <li (click)="_returnAdNew()" [class.ViewModeHiddenElement]="_pageState != 4">Edit Fields
                  </li> -->
                  <!-- <li [class.ViewModeHiddenElement]="_pageState == 1">Edit Forms</li> -->
                  <!-- <li class="wikiButton">Wiki</li> -->
                  <!-- <li
                  *ngIf="_pageState == 2"
                  class="wikiButton"
                  [class.disabled]="_deactivatedFieldsGridData?.length == 0"
                  (click)="_viewInactiveFields()"
                  >
                  View Inactive Fields
                </li> -->
              </ul>
              @if (_pageState != 1) {
                <div>
                  <button kendoButton
                    class="steps_buttons_class"
                    (click)="_onCancel()">
                    <img class="backimage"
                      [src]="'/assets/menu/'+ _theme +'/close-schedule-report-icon-green.svg'" />
                      <span>close</span>
                    </button>
                    <!-- <button
                    kendoButton
                    class="steps_buttons_class"
                    [disabled]="_pageState == 4 ? true : false"
                    (click)="_onSave('saveAndCopy')"
                    >
                    <img
                      class="backimage"
                      [src]="'/assets/menu/'+ _theme +'/save-icon-group.svg'"
                      />
                      <span>save & Copy</span>
                    </button> -->
                    <button kendoButton
                      class="steps_buttons_class"
                      [disabled]="_pageState == 4 ? true : false"
                      (click)="_onSave('saveAndNew')">
                      <img class="backimage"
                        [src]="'/assets/menu/'+ _theme +'/save-icon-group.svg'" />
                        <span>save & New</span>
                      </button>
                      <button kendoButton
                        class="steps_buttons_class"
                        [disabled]="_pageState == 4 ? true : false"
                        (click)="_onSave('saveAndClose')">
                        <img class="backimage"
                          [src]="'/assets/menu/'+ _theme +'/save-icon-group.svg'" />
                          <span>save & Close</span>
                        </button>
                        <button kendoButton
                          class="steps_buttons_class"
                          [disabled]="_pageState == 4 ? true : false"
                          (click)="_onSave('save')">
                          <img class="backimage"
                            [src]="'/assets/menu/'+ _theme +'/save-icon-group.svg'" />
                            <span>save</span>
                          </button>
                        </div>
                      }
                    </div>
                  </div>
                  <div class="col-12">
                    <div class="formsMenuSeparator"></div>
                  </div>
                </div>
                <div>
                  <div class="row row_padding">
                    <fieldset class="col-12 col-xl-6">
                      @if (_pageState == 3) {
                        <div class="form-group from_but_container special_style_formgroup margin-top-10"
                          >
                          <label class="control-label leftLabel" style="float: left">
                            {{getLabel("LBL_VideoFileName")?.currentText}}
                          </label>
                          <a (click)="downloadFile(_filePath, model.name)" [download]="model.name" style="cursor:pointer; color:blue">{{model.name}}</a>
                        </div>
                      }
                      @if (_pageState == 2 || _pageState == 4) {
                        <div class="form-group from_but_container special_style_formgroup margin-top-10"
                          >
                          <label class="control-label leftLabel" style="float: left">
                            {{getLabel("LBL_VideoFileName")?.currentText}}
                          </label>
                          <div #kendo_uploader_wrapper>
                            <kendo-upload #kendo_uploader
                              [saveUrl]="uploadSaveUrl"
                              [removeUrl]="uploadRemoveUrl"
                              [batch]="false"
                              [autoUpload]="false"
                              [class.active]="_isActiveImage"
                              [multiple]="false"
                              [disabled]="CheckIfWeAreInEditMode()"
                              class="NextToLabelUpload newFormControlWidth requiredDropZone"
                              (select)="_fileSelectedChanges($event)"
                              (keyup.enter)="_selectedimageSubmited()"
                              (keydown.Tab)="_selectedimageSubmited()"
                              (remove)="_fileRemoveEventHandler()"
                              formControlName="stream">
                              <kendo-upload-messages [select]="'Select Video Or Drag To Upload'"
                                [dropFilesHere]="''">
                              </kendo-upload-messages>
                            </kendo-upload>
                          </div>
                          <span class="picture-form-external-upload-btn"
                            (click)="_onUploadClick()"
                            [class.ViewModeHiddenElement]="_pageState == 4">
                            <img [src]="'/assets/menu/'+ _theme +'/pictures-icon.svg'" />
                          </span>
                          <a [class.editfieldsIconvisible]="_pageState == 4"
                            class="editFieldsIcon"
                            (click)="_openRenameForm('LBL_VideoFileName', true)">
                            <img class="searchIcon"
                              [src]="'/assets/menu/'+ _theme +'/edit-icon.svg'" />
                            </a>
                          </div>
                        }
                        @if (getAuthByLabel('LBL_VideoTitle')?.canView) {
                          <div
                            KendoToolTip
                            class="form-group from_but_container special_style_formgroup margin-top-10">
                            <label class="control-label">{{getLabel("LBL_VideoTitle")?.currentText}}</label>
                            <input #Kendo_Image_Title_Input
                              type="text"
                              class="k-textbox writebox newFormControlWidth"
                              (keyup.enter)="_imagetitleSubmited()"
                              (keydown.Tab)="_imagetitleSubmited()"
                              (focus)="_imagetitleFocus()"
                              [class.ViewModeDisabledControl]="_pageState == 1"
                              formControlName="title"
                              placeholder="Enter A Title"
                              [attr.disabled]="getAuthByLabel('LBL_VideoTitle')?.canEdit ? null : 'disabled'"
                              [attr.required]="getLabel('LBL_VideoTitle')?.isRequired ? 'required' : null" />
                              <span class="inputSkipButton" (click)="_skipUnitTitle()">
                                skip<img [src]="'/assets/menu/'+ _theme +'/yellow-skip-arrow.svg'" />
                              </span>
                              <a title="Edit {{getLabel('LBL_VideoTitle')?.currentText}}"
                                [class.editfieldsIconvisible]="_pageState == 4"
                                class="editFieldsIcon"
                                (click)="_openRenameForm('LBL_VideoTitle')">
                                <img class="searchIcon"
                                  [src]="'/assets/menu/'+ _theme +'/edit-icon.svg'" />
                                </a>
                              </div>
                            }
                            @if (getAuthByLabel('LBL_VideoDescription')?.canView) {
                              <div
                                KendoToolTip
                                class="form-group from_but_container special_style_formgroup margin-top-10">
                                <label class="control-label">{{getLabel("LBL_VideoDescription")?.currentText}}</label>
                                <input #Kendo_Image_Description_Input
                                  type="text"
                                  class="k-textbox writebox newFormControlWidth"
                                  (keyup.enter)="_imageDescriptionSubmited()"
                                  (keydown.Tab)="_imageDescriptionSubmited()"
                                  (focus)="_imagedescFocus()"
                                  [class.ViewModeDisabledControl]="_pageState == 1"
                                  formControlName="description"
                                  placeholder="Enter A Description"
                                  [attr.disabled]="getAuthByLabel('LBL_VideoDescription')?.canEdit ? null : 'disabled'"
                                  [attr.required]="getLabel('LBL_VideoDescription')?.isRequired ? 'required' : null" />
                                  <span class="inputSkipButton" (click)="_skipUnitName()">
                                    skip<img [src]="'/assets/menu/'+ _theme +'/yellow-skip-arrow.svg'" />
                                  </span>
                                  <a title="Edit {{getLabel('LBL_VideoDescription')?.currentText}}"
                                    [class.editfieldsIconvisible]="_pageState == 4"
                                    class="editFieldsIcon"
                                    (click)="_openRenameForm('LBL_VideoDescription')">
                                    <img class="searchIcon"
                                      [src]="'/assets/menu/'+ _theme +'/edit-icon.svg'" />
                                    </a>
                                  </div>
                                }
                              </fieldset>
                            </div>
                            @if (_currentUser.isEnterprise) {
                              <asap-account-sites-selection
                                [selectedAccounts]="_selectedAccounts"
                                [disabled]="_pageState != 2"
                                [class.disabled]="_pageState != 2"
                                [enableSiteSelection]="false"
                                [filteringEnable]="false"
                                [resolver]="_getAccounts"
                                (onRowSelectionChanges)="_onAccountRowSelectionChanges($event)">
                              </asap-account-sites-selection>
                            }
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row no_row_margin">
                      <div class="col-12">
                        <button kendobutton
                          class="addNewtabButton k-button"
                          (click)="_addNewTab()">
                          <img class="backimage"
                            src="/assets/menu/enterprise/add-icon-green.svg" /><span>Add New Tab</span>
                          </button>
                        </div>
                      </div>
                      <div class="row no_row_margin">
                        <div class="col-12">
                          <button kendobutton
                            class="reorderTabButton k-button"
                            (click)="_reorderingtabs()">
                            <img class="backimage"
                              src="/assets/menu/enterprise/reorder-tabs-icon.svg" /><span>reorder tabs</span>
                            </button>
                          </div>
                        </div>
                        @if (model && model.thumbnail) {
                          <div
                            class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 mt-3">
                            <label class="control-label leftLabel" style="float: left">Preview image</label>
                            <img [src]="_storagePath + model.thumbnail" class="preview-image" />
                          </div>
                        }
                        <div class="row">
                          <div class="col-12">
                            @if (_invalidForm) {
                              <asap-forms-validation-summary
                                [form]="_form"
                                [page]="'pictures'">
                              </asap-forms-validation-summary>
                            }
                          </div>
                        </div>
                      </form>
                      @if (CheckIfWeAreInEditMode()) {
                        <div class="asap-footer">
                          <ul class="asap-footer-content-list">
                            <li>
                              <span class="label-footer">Date Added:</span>{{
                              $safeNavigationMigration(model?.createdOn) |
                              dateFormat
                              }}<span class="separator">.</span><span class="label-footer">Added By User:</span>{{
                              model?.createdUser?
                              model?.createdUser.userName : null
                              }}
                            </li>
                            <li>
                              <span class="label-footer">Last Edited:</span>{{
                              $safeNavigationMigration(model?.lastUpdatedOn) |
                              dateFormat
                              }}<span class="separator">.</span><span class="label-footer">Last Edited By User:</span>{{model?.updatedUser? model?.updatedUser.userName : null}}
                            </li>
                          </ul>
                        </div>
                      }
                    </kendo-window>
                  }

                  @if (_editFormActive) {
                    <kendo-window
                      title="{{ _isCustomfieldsFormValue ? 'Add Custom Fields' : (_isAddTabFormValue ? 'Add New Tabs' : (_isRenameFormValue ? 'Edit Record' : '')) }}"
                      (close)="_closeCustomFields()"
                      class="customFieldsWindow">
                      <asap-custom-fields [accounts]="_selectedAccountIds"
                        [tabGroup]="_selectedTabId"
                        [labelId]="_selectedLabelId"
                        [labelObjectCode]="_selectedLabelObjectCode"
                        [formName]="'stock'"
                        page="files"
                        [isCustomfieldsForm]="_isCustomfieldsFormValue"
                        [isCustomtabsForm]="_isAddTabFormValue"
                        [isRenameForm]="_isRenameFormValue"
                        [language]="_language"
                        [isRenameCustomForm]="_isRenameCustomFormValue"
                        [isRenameLabel]="_isRenameLabel"
                        [isMandatory]="_isMandatory"
                        (closePopup)="ClosePopup($event)"
                        [permissionScope]="_permissionScope">
                      </asap-custom-fields>
                    </kendo-window>
                  }

                  @if (_orderingTabsForm) {
                    <kendo-window title="Tab Reordering" (keydown.enter)="$event.preventDefault()" (close)="_closeOrderingTabsForm()">
                      <div class="row no_row_margin margin-top-30">
                        @if (false) {
                          <div class="col-12 margin-top-10">
                            <div class="form-group">
                              <label for="itemType" class="control-label">Tab 1</label>
                              <kendo-combobox [data]="_dataTabsSelected"
                                [suggest]="true"
                                [textField]="'name'"
                                [valueField]="'name'"
                                placeholder="Accounts/Sites"
                                class="newFormControlWidth disabled">
                              </kendo-combobox>
                            </div>
                          </div>
                        }
                        @for (item of _dataTabs ; track item; let i = $index) {
                          <div class="col-12 margin-top-10">
                            <div class="form-group">
                              <label for="itemType" class="control-label">Tab {{ i + 1 }}</label>
                              <kendo-combobox [data]="_dataTabsSelected"
                                [suggest]="true"
                                [textField]="'name'"
                                [valueField]="'name'"
                                [placeholder]="item.name"
                                required
                                class="bordered newFormControlWidth"
                                (valueChange)="_comboValueChange($event,i)">
                              </kendo-combobox>
                            </div>
                          </div>
                        }
                      </div>
                      <div class="row no_row_margin">
                        <div class="col-12">
                          <button kendoButton class="steps_buttons_class" (click)="_onSaveTabOrdering()">
                            <img class="backimage" [src]="'/assets/menu/'+ _theme +'/save-icon-group.svg'" />
                            <span>save & Close</span>
                          </button>
                        </div>
                      </div>
                    </kendo-window>
                  }

                  @if (_deactivatedFieldsForm) {
                    <kendo-window title="Deactivated Fields" (close)="_closeInactiveFields()">
                      <div class="row no_row_margin margin-top-30">
                        <div class="col-12 margin-top-10">
                          <kendo-grid [data]="_deactivatedFieldsGridData" [scrollable]="'none'">
                            <kendo-grid-column field="name" title="Fields Name">
                            </kendo-grid-column>
                            <kendo-grid-column field="formTab.name" title="Tab Name">
                            </kendo-grid-column>
                            <kendo-grid-column field="createdOn" title="Added Date" type="date">
                              <ng-template kendoGridCellTemplate let-dataItem>
                                {{dataItem.createdOn | dateFormat}}
                              </ng-template>
                            </kendo-grid-column>
                            <kendo-grid-column field="lastUpdatedOn" title="Deactivation Date" type="date">
                              <ng-template kendoGridCellTemplate let-dataItem>
                                {{dataItem.lastUpdatedOn | dateFormat}}
                              </ng-template>
                            </kendo-grid-column>
                            <kendo-grid-column field="Command" title="Command">
                              <ng-template kendoGridCellTemplate let-dataItem>
                                <div class="action-button action-button-deactivate"
                                  (click)="_reactivate(dataItem)">
                                  <div class="action-button-icon">
                                    <img src="/assets/menu/enterprise/deactivate-icon.svg" />
                                  </div>
                                  <div class="edit-icon-text">Reactivate</div>
                                </div>
                              </ng-template>
                            </kendo-grid-column>
                          </kendo-grid>
                        </div>
                      </div>
                    </kendo-window>
                  }

                  @if (_isEditForms) {
                    <asap-edit-forms
                      (close)="_onCloseEditForms($event)"
                      (saved)="_closeCustomFields()"
                      [page]="_page"
                      [permissionScope]="_permissionScope">
                    </asap-edit-forms>
                  }
